import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './TermsAndConditions.css';

function PrivacyPolicy() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    
    return (
        <div>
        <div className="lp-topbar">
            <Link to="/" className="lp-logo lp-logo-pointer"><div className="lp-logo"><img src="/logo.png" alt="aistCRM" className="logo-img" /></div></Link>
            <Link to="/login" className="lp-login-btn">Login</Link>
        </div>

        <div className="terms-and-conditions-container">
            <h1>Privacy Policy</h1>
            <div className="terms-content">
                <p class="tc-effective-date"><strong>Effective Date:</strong> 02/23/2026</p>

                <section class="tc-section">
                    <h2 class="tc-heading">1. Introduction</h2>
                    <p class="tc-text">
                    This Privacy Policy explains how aistCRM collects, uses, and protects personal information
                    in connection with our CRM platform for language schools.
                    </p>
                </section>

                <section class="tc-section">
                    <h2 class="tc-heading">2. Roles</h2>
                    <p class="tc-text">
                    aistCRM acts as a Data Processor for student data uploaded by schools.
                    Schools are responsible as Data Controllers.
                    </p>
                </section>

                <section class="tc-section">
                    <h2 class="tc-heading">3. Information We Collect</h2>
                    <ul class="tc-list">
                    <li>Name and email address</li>
                    <li>Organization name</li>
                    <li>Billing information</li>
                    <li>Student data uploaded by schools</li>
                    <li>IP address and usage logs</li>
                    </ul>
                </section>

                <section class="tc-section">
                    <h2 class="tc-heading">4. How We Use Information</h2>
                    <ul class="tc-list">
                    <li>Provide and maintain the Service</li>
                    <li>Process subscriptions and payments</li>
                    <li>Improve functionality</li>
                    <li>Ensure security</li>
                    </ul>
                    <p class="tc-text">
                    We do not sell personal data.
                    </p>
                </section>

                <section class="tc-section">
                    <h2 class="tc-heading">5. Data Sharing</h2>
                    <p class="tc-text">
                    We may share data with cloud hosting providers, payment processors,
                    and infrastructure providers solely to operate the Service.
                    </p>
                </section>

                <section class="tc-section">
                    <h2 class="tc-heading">6. International Transfers</h2>
                    <p class="tc-text">
                    Data may be processed in Chile, the United States, or other jurisdictions
                    where our service providers operate.
                    </p>
                </section>

                <section class="tc-section">
                    <h2 class="tc-heading">7. Data Security</h2>
                    <p class="tc-text">
                    We implement reasonable technical and organizational measures,
                    including encrypted connections (HTTPS) and access controls.
                    </p>
                </section>

                <section class="tc-section">
                    <h2 class="tc-heading">8. FERPA Disclaimer</h2>
                    <p class="tc-text">
                    aistCRM acts as a service provider to educational institutions.
                    Schools are responsible for compliance with FERPA and other applicable laws.
                    </p>
                </section>

                <section class="tc-section">
                    <h2 class="tc-heading">9. Contact</h2>
                    <p class="tc-text">
                    Email: support@aistcrm.com<br/>
                    Owner: Miloslav Mylnikov, RUT - 28.581.607-6, Individual Entrepreneur – Chile
                    </p>
                </section>
            </div>
        </div>
        </div>
    );
}

export default PrivacyPolicy;
